import { HOST_API_KEY } from "../../config";
import { axiosInstanceWithToken } from "@/utils/axios";

export const getChatRoomsByUser = async (userId) => {
  const request = await axiosInstanceWithToken.get(`${HOST_API_KEY}/chat-room/user/${userId}`);
  return request?.data;
};

export const getChatRoomMessages = async (chatRoomId, cursor, limit) => {
  let url = `${HOST_API_KEY}/chat-room/${chatRoomId}/messages?limit=${limit}`
  if (cursor) url += `&cursor=${cursor}`
  const request = await axiosInstanceWithToken.get(url);
  return request?.data;
};

export const getFollowingForChat = async (userId, search = "") => {
  const request = await axiosInstanceWithToken.get(`${HOST_API_KEY}/chat/following/${userId}?search=${search}`);
  return request?.data;
}

export const sendMessageToChatRoom = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/messages/create`, body);
  return request?.data;
}

export const createNewChatRoom = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/create`, body);
  return request?.data;
}

export const addReactionToMessage = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/messages/reaction`, body);
  return request?.data;
}

export const updateChatRoomParticularMessage = async (messageId, messageContent, userId) => {
  const request = await axiosInstanceWithToken.put(`${HOST_API_KEY}/chat-room/messages/${messageId}`, {
    messageContent,
    userId
  });
  return request?.data;
};

export const blockChatRoomUser = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/user/block`, body);
  return request?.data;
}

export const unblockChatRoomUser = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/user/unblock`, body);
  return request?.data;
}

export const markMessagesAsRead = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/messages/read`, body);
  return request?.data;
}

export const deleteAllMessages = async (body) => {
  const request = await axiosInstanceWithToken.delete(`${HOST_API_KEY}/chat-room/messages`, {
    data: body,
  });
  return request?.data;
};

export const getTotalUnreadMessageCount = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/messages/unread-count`, body);
  return request?.data;
};

export const togglePinChatRoom = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/pin`, body);
  return request?.data;
};

export const pinMessage = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/messages/pin`, body);
  return request?.data;
};

export const unpinMessage = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/messages/unpin`, body);
  return request?.data;
};

export const getPinnedMessages = async (body) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/chat-room/messages/getPinnedMessages`, body);
  return request?.data;
};